import { render, staticRenderFns } from "./ChainBPJsonStatus.vue?vue&type=template&id=1ff57402"
import script from "./ChainBPJsonStatus.vue?vue&type=script&lang=js"
export * from "./ChainBPJsonStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports